import { createStore } from "vuex";

export default createStore({
  state: {
    user: JSON.parse(localStorage.getItem("user")) || null, // Load from localStorage
  },
  getters: {
    getUser: (state) => state.user,
    isAuthenticated: (state) => !!state.user,
  },
  mutations: {
    setUser(state, userData) {
      state.user = userData;
      localStorage.setItem("user", JSON.stringify(userData)); // Persist in localStorage
    },
    logout(state) {
      state.user = null;
      localStorage.removeItem("user");
    },
  },
  actions: {},
  modules: {},
});
